import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import Alert from "components/v2/Alert/Alert";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import { ShipmentTypes } from "../../../../../constants";

type QuoteMultiDropBannerProps = {
  isQuickRequest?: boolean;
};

const QuoteMultiDropBanner = function (props: QuoteMultiDropBannerProps) {
  const navigate = useNavigate();
  const { isQuickRequest } = props;

  const shipmentId = useParams()?.id;
  const [showMultidropAlert, setShowMultidropAlert] = useState(true);

  const { data: shipmentData } = useGetShipmentBasic(shipmentId!, {
    enabled: !isQuickRequest && !!shipmentId,
    refetchOnMount: false,
  });

  const isMultidropShipment = [ShipmentTypes.MULTIDROP, ShipmentTypes.MULTISTOP].includes(
    shipmentData?.shipment?.shipment_type || false,
  );
  const showMultidropAlertCondition = isMultidropShipment && showMultidropAlert;

  const handleClickShipmentDetails = () => {
    navigate(`/shipment/${shipmentId}/detail`);
  };

  if (!showMultidropAlertCondition) return null;

  return (
    <div className="mb-xl">
      <Alert
        variant="brand"
        label=""
        onClose={() => {
          setShowMultidropAlert(false);
        }}
      >
        <span className="font-regular">
          <FormattedMessage
            id="shipment-quotes.components.quotes.multiStopInfoMessage1"
            defaultMessage="This is a multistop shipment. To view all stops, go to the Shipment Details tab."
          />
        </span>{" "}
        <span className="text-decoration-underline cursor-pointer" onClick={handleClickShipmentDetails}>
          <FormattedMessage id="shipment-quotes.components.quotes.multiStopInfoMessage2" defaultMessage="Shipment Details" />
        </span>{" "}
        <span>
          <FormattedMessage id="shipment-quotes.components.quotes.multiStopInfoMessage3" defaultMessage="tab." />
        </span>
      </Alert>
    </div>
  );
};

export default QuoteMultiDropBanner;

QuoteMultiDropBanner.defaultProps = {
  isQuickRequest: false,
};
